$(document).ready(function() {
  var $carousel1 = $('.carousel-main').flickity({
    arrowShape: {
      x0: 10,
      x1: 50, y1: 35,
      x2: 55, y2: 30,
      x3: 20
    },
    wrapAround: true
  });
  // 2nd carousel, navigation
  $('.carousel-nav').flickity({
    asNavFor: '.carousel-main',
    contain: true,
    pageDots: false,
    prevNextButtons: false
  });
});
